<template>
  <div class="hero">
    <div class="videoWrapper">
    <iframe width="100%" height="auto" src="https://www.youtube.com/embed/DU8m4CU4SbU?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pride-hero',
    mounted() {
      this.screenSize = '';      
      this.setVideoSrc();
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.setVideoSrc);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.setVideoSrc);
    },
    methods: {
      checkWidth(){
        if (window.innerWidth < 768){
          return 'mobile';
        } else {
          return 'desktop'
        }
      },
      setVideoSrc(){       

        let screenSize = this.checkWidth();

        // return if no breakpoint is crossed
        if (screenSize === this.screenSize) return;

        if (screenSize === 'mobile'){
          this.screenSize = 'mobile';
          this.$refs.source.setAttribute('src', 'static/videos/Side_Broken_Dish.mp4');
          this.$refs.video.load();
        } else {
          this.screenSize = 'desktop';
          this.$refs.source.setAttribute('src', 'static/videos/Side_Broken_Dish.mp4');
          this.$refs.video.load();
        }
      },
      isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.bottom >= 0 &&
          rect.top <= (window.innerHeight || html.clientHeight)
        );
      },
    }
  };
</script>

<style lang='scss' scoped>
  @import '../../variables';

  .hero {
    font-size:0;

    .videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
      overflow: hidden;
    }

    .videoWrapper iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }


    // video {
    //   width: 100%;
    // }
  }



</style>



// WEBPACK FOOTER //
// src/components/pride/PrideHero.vue